module.exports = __webpack_public_path__ + "static/media/515GriffinStNW_2018-06-05_3.7efb7fee.jpg";